<template>
  <div :class="control.class">
    <label v-if="control.label" :for="control.uuid" class="label"
      :style="{ color: control.brand_colour ? '#000000' : undefined }">
      {{ control.label }}
      <span v-if="control.rules && control.rules.split('|').includes('required')"
        :style="{ color: control.brand_colour ?? 'rgb(253 1 130 / var(--tw-text-opacity))' }">
        *
      </span>
    </label>
    <input
      v-model="value"
      :name="control.name"
      :id="control.uuid"
      :type="control.type"
      :maxlength="control.max"
      :minlength="control.min"
      :readonly="control.readonly"
      :placeholder="control.placeholder"
      :aria-label="control.placeholder"
      :disabled="control.disabled"
      autocomplete="off"
      class="appearance-none placeholder-gray-400 py-3 px-4 border border-white/10 bg-white/5 rounded-lg block transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-opacity-25 focus:border-current disabled:opacity-50 disabled:cursor-not-allowed w-full"
      :style="{
        '--tw-ring-color': control.brand_colour ?? '#d4016d',
        '--tw-border-color': control.brand_colour ?? '#d4016d',
        backgroundColor: control.brand_colour ? '#f5f5f5' : undefined
      }"
    />
    <Error v-if="errorMessage" :style="{ color: 'red' ?? 'rgb(253 1 130 / var(--tw-text-opacity))' }">
      {{ errorMessage }}
    </Error>
    <Note v-if="control.note">{{ control.note }}</Note>
  </div>
</template>
<script setup>
import { useField } from 'vee-validate'
const props = defineProps({
  control: Object
})
const { value, errorMessage } = useField(
  props.control.name,
  props.control.rules,
  {
    label: props.control.label
  }
)
</script>
